import { Component, Input, OnInit } from '@angular/core';
import { ModalController, ActionSheetController } from '@ionic/angular';
import { JavapiService } from '../../services/javapi.service';
import { MetodosgenService } from '../../services/metodosgen.service';
import { Metodosui } from '../../services/metodosui';
import { firstValueFrom } from 'rxjs';

@Component({
  selector: 'app-facturafiscal',
  templateUrl: './facturafiscal.component.html',
  styleUrls: ['./facturafiscal.component.scss'],
  standalone: false
})
export class FacturaFiscalComponent implements OnInit {

  @Input() factura: any;
  userData: any;

  fiscalData = {
    factura_fiscal: '',
    fecha_factura_fiscal: '',
    paquete: '',
    fecha_pago: '',
    tipo_pago: '',
    notas: ''
  };

  constructor(
    private modalCtrl: ModalController,
    private actionSheetCtrl: ActionSheetController,
    private javapiService: JavapiService,
    private metodosGenService: MetodosgenService,
    private metodosUi: Metodosui
  ) { }

  ngOnInit() {
    const userJson = localStorage.getItem('user');
    if (userJson) {
      this.userData = JSON.parse(userJson);
    }
    // Set today as default
    this.fiscalData.fecha_factura_fiscal = new Date().toISOString().split('T')[0];
    this.loadExistingData();
  }

  async loadExistingData() {
    if (!this.factura?.cotizacionId) return;
    const cotId = this.factura.cotizacionId.split(',')[0];

    try {
      const payload = this.metodosGenService.setModeloGeneral('genModel', 'factura_empresa_get_fiscal', cotId, '', '', '', '', '', '', '', '', '', '', '', '', '', '');
      const data: any = await firstValueFrom(this.javapiService.getCommonModel(payload));
      
      const record = Array.isArray(data) ? data[0] : data;
      if (record && (record.dt1 !== undefined || record.factura_fiscal !== undefined)) {
        this.fiscalData = {
          factura_fiscal: record.dt1 || '',
          fecha_factura_fiscal: record.dt2 || new Date().toISOString().split('T')[0],
          paquete: record.dt3 || '',
          fecha_pago: record.dt4 || '',
          tipo_pago: record.dt5 || '',
          notas: record.dt6 || ''
        };
      }
    } catch (e) {
      console.error('Error loading fiscal data:', e);
    }
  }

  async selectTipoPago() {
    const actionSheet = await this.actionSheetCtrl.create({
      header: 'Seleccionar Tipo de Pago',
      cssClass: 'custom-action-sheet',
      buttons: [
        { text: 'Transferencia', handler: () => { this.fiscalData.tipo_pago = 'Transferencia'; } },
        { text: 'ACH', handler: () => { this.fiscalData.tipo_pago = 'ACH'; } },
        { text: 'Efectivo', handler: () => { this.fiscalData.tipo_pago = 'Efectivo'; } },
        { text: 'Cheque', handler: () => { this.fiscalData.tipo_pago = 'Cheque'; } },
        { text: 'Otro', handler: () => { this.fiscalData.tipo_pago = 'Otro'; } },
        { text: 'Cancelar', role: 'cancel' }
      ]
    });
    await actionSheet.present();
  }

  close() {
    this.modalCtrl.dismiss();
  }

  async confirmDelete() {
    const confirm = await this.metodosUi.showConfirmation('Limpiar Datos', '¿Desea borrar los datos fiscales y de pago de esta factura?', 'Limpiar');
    if (confirm) {
      this.save(true);
    }
  }

  async confirmSave() {
    const confirm = await this.metodosUi.showConfirmation('Guardar Datos', '¿Desea registrar la información proporcionada?', 'Guardar');
    if (confirm) {
      this.save(false);
    }
  }

  async save(isDelete: boolean) {
    if (!this.factura.cotizacionId) return;
    const ids = this.factura.cotizacionId.split(',').map((id: string) => id.trim()).filter((id: string) => id !== '');

    const facturaFiscal = isDelete ? '[DELETE]' : (this.fiscalData.factura_fiscal || '[DELETE]');
    const fechaFacturaFiscal = isDelete ? '[DELETE]' : (this.fiscalData.fecha_factura_fiscal || '[DELETE]');
    const paquete = isDelete ? '[DELETE]' : (this.fiscalData.paquete || '[DELETE]');
    const fechaPago = isDelete ? '[DELETE]' : (this.fiscalData.fecha_pago || '[DELETE]');
    const tipoPago = isDelete ? '[DELETE]' : (this.fiscalData.tipo_pago || '[DELETE]');
    const notas = isDelete ? '[DELETE]' : (this.fiscalData.notas || '[DELETE]');

    try {
      const loading = await this.metodosUi.showLoading('Guardando información...', 'blue');
      
      for (const cotId of ids) {
        const savePayload = this.metodosGenService.setModeloGeneral(
          'genUpdate', 'record_fiscal_invoice',
          cotId,
          facturaFiscal,
          paquete,
          fechaPago,
          tipoPago,
          notas,
          String(this.factura.id),
          this.factura.fecha || '',
          fechaFacturaFiscal,
          this.userData?.l_usuario || 'APP',
          '', '', '', '', ''
        );

        await firstValueFrom(this.javapiService.getCommonModel(savePayload));
      }

      await this.metodosUi.hideLoading();
      this.metodosUi.showToast(isDelete ? 'Datos eliminados' : 'Datos guardados con éxito', 'success');
      this.modalCtrl.dismiss({ saved: true });

    } catch (e) {
      console.error('Error saving fiscal data:', e);
      await this.metodosUi.hideLoading();
      this.metodosUi.showToast('Error al guardar la información', 'danger');
    }
  }
}
